import TagFormatter from "../../../module/overview/Table/Formatters/TagFormatter";

export default {
  loading: true,
  appointments: null,
  providers: null,
  patientTags: null,
  isProvidersExists: true,
  selectedProvider: null,
  selectedPatientTag: null,
  originalTableData: [],
  patientsTableDataForSafe: [],
  patientsTableDataForProvider: [],
  tableData: [
    {
      procedureDate: {
        label: "July 10",
        type: "",
      },
      patient: {
        label: "0781-2616",
        subLabel: "Active This Week",
        route: "",
      },
      nextEvent: {
        label: "Follow-up Lumber",
        subLabel: "Dec 11",
        route: "",
      },
      site: "Dr. Keshav Singh",
      surveys: {
        label: 3,
      },
      qnairs: {
        label: "6 of 7",
        route: "",
      },
      files: {
        label: 3,
        route: "",
      },
      records: {
        label: 1,
        route: "",
      },
    },
  ],
};
